import { Chart, Margin, ArgumentAxis, Grid, Series, CommonSeriesSettings, Export, Tooltip, Legend, Label } from 'devextreme-react/chart';
import "./Barras.css";
import { LVForm } from "../../Basicos/LVForm";
import { SimpleItem } from 'devextreme-react/form';


export const LineasMultiples = ({ icono, titulo, dataSourceTipos, dataSourceDatos, PaletaColor }) => {

  const customizeTooltip = (pointInfo) => ({
    html: `<div><div class="tooltip-header">${pointInfo.argumentText
      }</div><div class="tooltip-body"><div class="series-name"><span class='top-series-name'>${pointInfo.points[0].seriesName
      }</span>: </div><div class="value-text"><span class='top-series-value'>${pointInfo.points[0].valueText
      }</span></div></div>`,
  });

  return (
    <div className="barras">
      <LVForm
        colCount={1}>
        <SimpleItem>
          <div className="title">
            {icono} {titulo}
          </div>
          <br />
          <Chart
            palette={PaletaColor}
            dataSource={dataSourceDatos}
          >
            <CommonSeriesSettings
              argumentField="arg"
              type='Spline'
            />
            {
              dataSourceTipos.map((item) => <Series
                key={item.value}
                valueField={item.value}
                name={item.name} />)
            }
            <Margin bottom={20} />
            <ArgumentAxis
              valueMarginsEnabled={false}
              discreteAxisDivisionMode="crossLabels"
            >
              <Label overlappingBehavior="auto" />
              <Grid visible={true} />
            </ArgumentAxis>

            <Tooltip enabled={true} shared={true} customizeTooltip={customizeTooltip} />

            <Legend
              verticalAlignment="bottom"
              horizontalAlignment="center"
              itemTextPosition="bottom"
            />
            <Export enabled={true} />
            {/* <Title text="Energy Consumption in 2004">
            <Subtitle text="(Millions of Tons, Oil Equivalent)" />
          </Title> */}
          </Chart>
        </SimpleItem>
      </LVForm>
    </div>
  );
};
